import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import {Team} from "@teammood/team";
import { Component, Inject, ViewChild, ChangeDetectionStrategy } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { TeamDefaultsSettingsFormComponent } from "../team-defaults-settings-form/team-defaults-settings-form.component";
import { TeamService } from "@teammood/team";
import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { LoggerService } from "@teammood/shared/util/logger";

@Component({
    selector: 'new-team-dialog',
    templateUrl: './new-team-dialog.component.html',
    styleUrls: ['./new-team-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    MatDialogModule,
    MatSelectModule,
    ReactiveFormsModule,
    TeamDefaultsSettingsFormComponent
]
})
export class NewTeamDialogComponent {

    @ViewChild(TeamDefaultsSettingsFormComponent)
    teamForm: TeamDefaultsSettingsFormComponent;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: NewTeamData,
        public dialogRef: MatDialogRef<NewTeamDialogComponent, Team>,
        private snackBarService: SnackBarService,
        private teamService: TeamService,
        private logger: LoggerService,
    ) { }
    
    async create(): Promise<void> {
        const newTeamSettings = this.teamForm.form.getRawValue();
        const newTeam = { ...this.data.team, ...newTeamSettings }
        if (newTeam.moodsDisplayTime.time === null || newTeam.moodsDisplayTime.timeZone === null) {
            newTeam.moodsDisplayTime = null
        }

        try {
            const createdTeam = await this.teamService.create(this.data.teamId, newTeam);
            this.snackBarService.success('teamCreated');
            this.dialogRef.close(createdTeam);
        } catch (error) {
            this.logger.error(error.data);
        }
    }

    close() {
        this.dialogRef.close();
    }
}

export interface NewTeamData {
    team: Team,
    teamId: string
}